export default function (range) {
  return range && (range.from != null || range.to != null);
}
